const setSpaces = (num) => {
  let val = ''
  val = num.toString().split('').reverse()
  for (let i = 1; i < val.length; i++) {
    if (i % 3 === 0) {
      val[i] = `${val[i]} `
    }
  }
  val = val.reverse().join('')
  return val
}

export function formatNumberToThousandths (num) {
  if (num < 1000000) {
    return setSpaces(num)
  }

  return num > 1000000000 ? setSpaces((num / 1000000).toFixed(0)) + 'B' : setSpaces((num / 1000).toFixed(0)) + 'M'
}

export function formatNumAsString (value) {
  if (!value) {
    return value
  }

  const hasFloatPart = value.toString().includes('.')

  if (!hasFloatPart) {
    value = setSpaces(value)
  } else {
    let integerPart = value.toString().split('.')[0]
    let floatPart = value.toString().split('.')[1]
    integerPart = setSpaces(integerPart)
    floatPart = setSpaces(floatPart)
    value = `${integerPart}.${floatPart}`
  }

  return value
}
